module.exports = __webpack_public_path__ + "images/6c3c6063d706f80f8bfd4c4e0c93ed54.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/images/intro_video/ksenia_thumb.jpg
// module id = 148
// module chunks = 24